<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Processando...</p>
</ngx-spinner>
<section class="d-flex flex-column p-4">
  <div class="mb-3">
    <h3>Extrato Processamento EFD</h3>
  </div>

  <div class="d-flex flex-column py-1 px-3">

    <div class="d-flex gap-4 mt-2">
      <mat-form-field appearance="fill" class="w-50">
        <mat-label style="font-size: 14px">Período Inicial</mat-label>
        <input matInput mask="00/0000" required [formControl]="periodoInicialControl" minlength="3" (blur)="podeConsultar()"/>
        <mat-hint>MM/AAAA</mat-hint>
        <mat-error *ngIf="periodoInicialControl.invalid && (periodoInicialControl.dirty || periodoInicialControl.touched)">
          {{periodoInicialControl.errors?.invalidDate}}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-50">
        <mat-label style="font-size: 14px">Período Final</mat-label>
        <input matInput mask="00/0000" required [formControl]="periodoFinalControl" minlength="3" (blur)="podeConsultar()"/>
        <mat-hint>MM/AAAA</mat-hint>
        <mat-error *ngIf="periodoFinalControl.invalid && (periodoFinalControl.dirty || periodoFinalControl.touched)">
          {{periodoFinalControl.errors?.invalidDate}}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="d-flex gap-4 mt-3">
      <sfz-button title="Limpar" startIcon="trash" (click)="limpar()" size="md"></sfz-button>
      <sfz-button title="Consultar Extrato"
        startIcon="search"
        [disabled]="!consultarHabilitado"
        (click)="consultar()"
        size="md"></sfz-button>
    </div>

  </div>

  <div *ngIf="exibirResultado" class="mt-3">

    <div class="d-flex justify-content-left">
      <div *ngFor="let categoria of categorias" class="d-flex flex-column align-items-left w-30 content-border m-2" style="zoom: 0.9">
        <mat-label class="m-2" style="font-size: 1.1rem; font-weight: 600;">{{ categoria.nome }}</mat-label>
        <div class="m-2">
          <mat-radio-group [value]="categoria.valorSelecionado" (change)="selecionarOpcao(categoria, $event)">
            <mat-radio-button *ngFor="let opcao of opcoes" [value]="opcao">
              {{ opcao.texto }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
    </div>

    <table mat-table matSort
      [dataSource]="dataSource"
      [matSortActive]="sortColumn"
      [matSortDirection]="sortDirection"
      (matSortChange)="aoOrdenar($event)"
      class="mat-elevation-z8"
      aria-label="Lista de extratos de processamento EFD">

      <ng-container *ngFor="let columnDef of definicaoColunas">
        <ng-container [matColumnDef]="columnDef.column">
          <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="!columnDef.sortable" [ngClass]="columnDef.class"> {{ columnDef.header }} </th>
          <td mat-cell *matCellDef="let valorColuna">
            <ng-container *ngIf="columnDef.column === 'statusSolicitacao'; else statusExtratoCell">
              <span [ngClass]="{
                'badge-warning': valorColuna[columnDef.column] === 'Solicitado',
                'badge-success': valorColuna[columnDef.column] === 'Concluído',
                'badge-danger': valorColuna[columnDef.column] === 'Erro',
                'badge-info': valorColuna[columnDef.column] === 'Desconhecido'
              }">
                {{ valorColuna[columnDef.column] ?? '—' }}
              </span>
            </ng-container>
            <ng-template #statusExtratoCell>
              <ng-container *ngIf="columnDef.column === 'statusExtrato'; else situacaoExtratoCell">
                <span [ngClass]="{
                  'badge-success': valorColuna[columnDef.column] === 'Processado',
                  'badge-warning': valorColuna[columnDef.column] === 'Processado com pendência',
                  'badge-danger': valorColuna[columnDef.column] === 'Processado com alerta'
                }">
                  {{ valorColuna[columnDef.column] ?? '—' }}
                </span>
              </ng-container>
            </ng-template>
            <ng-template #situacaoExtratoCell>
              <ng-container *ngIf="columnDef.column === 'situacaoExtrato'; else actionCell">
                <span [ngClass]="{
                  'badge-info': valorColuna[columnDef.column] === 'Sem extrato',
                  'badge-success': valorColuna[columnDef.column] === 'Ativo',
                  'badge-warning': valorColuna[columnDef.column] === 'Inativo',
                  'badge-danger': valorColuna[columnDef.column] === 'Indefinido'
                }">
                  {{ valorColuna[columnDef.column] ?? '—' }}
                </span>
              </ng-container>
            </ng-template>
            <ng-template #actionCell>
              <ng-container *ngIf="columnDef.column === 'acoes'; else defaultCell">
                <button mat-icon-button class="acoes-menu-trigger" [matMenuTriggerFor]="menuAcoes" aria-label="Abrir ações do extrato">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menuAcoes="matMenu">
                  <button mat-menu-item (click)="baixarRelatorioEntregasArquivosEfd(valorColuna)">
                    <mat-icon>description</mat-icon>
                    <span>Baixar Extrato</span>
                  </button>
                </mat-menu>
              </ng-container>
            </ng-template>
            <ng-template #defaultCell> {{ valorColuna[columnDef.column] ?? '—' }} </ng-template>
          </td>
        </ng-container>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="tituloColuna"></tr>
      <tr mat-row *matRowDef="let row; columns: tituloColuna;"></tr>
    </table>

    <div style="display: flex; align-items: center; justify-content: space-between; padding-top: 1rem;">
      <mat-paginator
          [length]="totalElementos"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          [pageSizeOptions]="[10, 20, 50]"
          showFirstLastButtons
          (page)="aoMudarPagina($event)">
      </mat-paginator>
    </div>
  </div>
</section>
